import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SttNoResults } from '../all';
import SttTimetableColumn from './SttTimetableColumn';

type Facility = {
    id?: number;
    name?: string;
    status?: string;
};

type Piece = {
    ini: string;
    end: string;
    duration: number;
    mark: string;
    title?: string;
    price?: number;
    capacity?: {
        free: number;
        total: number;
    };
    bookings?: { id: number; name?: string }[];
    percentagePaid?: number;
    isGame?: boolean;
    isGamePublic?: boolean;
    fixed?: boolean;
    notes?: string;
    players?: { id: number; name: string; img: { uri: string } }[];
    privilegesData?: unknown;
    timetableRates?: unknown;
    priceShape?: { currency?: string; locale?: string };
};

type Column = {
    facility: Facility;
    pieces: Piece[];
};

type Props = {
    weekTimetable: Column[];
    columnWidth?: number;
    onSelectPiece: (column: Column, piece: Piece) => void;
};

/**
 * Timetable week
 * ==============
 *
 * Props
 *
 *    * function onSelectPiece(piece)
 */
export function SttTimetableWeek({
    weekTimetable,
    columnWidth = 100,
    onSelectPiece,
}: Props): React.ReactElement {
    const { t } = useTranslation();

    // -----| Render |-----
    return (
        <div style={{ height: '50vh', margin: 0, padding: 0 }}>
            <Box
                style={{
                    maxHeight: '100%',
                    overflowX: 'auto',
                    overflowY: 'hidden',
                }}
            >
                <Box
                    className="timetable"
                    style={{ width: weekTimetable.length * columnWidth }}
                >
                    {weekTimetable &&
                        weekTimetable.map((col, idx) => (
                            <Box
                                key={idx}
                                className={`column ${
                                    col.facility &&
                                    col.facility.status === 'ONLY_SC'
                                        ? 'onlySC'
                                        : ''
                                }`}
                                style={{ width: columnWidth }}
                            >
                                <Box className="hd">
                                    {t(`day.${idx === 6 ? 0 : idx + 1}.name`)}
                                </Box>
                            </Box>
                        ))}
                </Box>
                <Box
                    className="timetable"
                    style={{ width: weekTimetable.length * columnWidth + 18 }}
                >
                    <Box
                        style={{
                            maxHeight: '40vh',
                            overflow: 'auto',
                            overflowX: 'hidden',
                        }}
                    >
                        {weekTimetable &&
                            weekTimetable.map((col, idx) => (
                                <SttTimetableColumn
                                    key={idx}
                                    column={col}
                                    onOpenPiece={onSelectPiece}
                                    width={columnWidth}
                                />
                            ))}

                        {weekTimetable && weekTimetable.length === 0 && (
                            <SttNoResults
                                paper
                                text={t('timetable.noFields')}
                            />
                        )}
                    </Box>
                </Box>
            </Box>
        </div>
    );
}
